var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Empty',{attrs:{"icon":"b-icon-bricks","header":"No item selected","content":"Select an item to view or edit it"}})
}
var staticRenderFns = []

export { render, staticRenderFns }